// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
    box-sizing: border-box;
    background-color: #1c1f25;
    border: 1px solid #3c616c;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.dialog-heading {
    font-size: 12px;
    text-align: center;
}

.dialog-button-container {
    display: flex;
    justify-content: center;
    gap: 4px;
    width: 100%;
    flex-wrap: wrap;
}

.dialog-button-container button {
    flex: 0 1 auto;
    min-width: 60px;
    background: transparent;
    border: 1px solid #244752;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
    color: #ffffff;
}

.dialog-button-container button:hover {
    border: 1px solid #71deff;
}

.dialog-button-container button img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
} 

.character-info-dialog-container {
    background-color: #1c1f25;
    border: 1px solid #3c616c;
    border-radius: 16px;
    padding: 16px 24px; 
    font-family: 'Kim';
} 

.character-info-dialog-card-container { 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    margin-bottom: 8px;
}

.character-info-dialog-card {
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center; 
    margin-right: 6px;
}

.character-info-dialog-card span {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    padding: 2px;
}

.character-info-dialog-card-text {
    display: flex;
    justify-content: space-between;
    /* min-width: 28px; */
    margin-right: 4px;
    font-size: 12px; 
    color: white;
}

.character-info-addition {
    display: flex;
} 

.character-info-dialog-control { 
    display: flex; 
    justify-content: center; 
    gap: 8px;
    color: white; 
    margin-bottom: 12px;
}

.character-info-dialog-control-btn { 
    padding: 4px 8px; 
    border: 1px solid #3c616c; 
    border-radius: 4px; 
} 

.character-info-dialog-control-btn:hover { 
    cursor: pointer; 
}

.character-info-dialog-control-val { 
    padding: 4px 24px; 
    border: 1px solid #3c616c; 
    border-radius: 4px; 
}

.character-info-dialog-container .dialog-button-container { 
    justify-content: center;
}

.dialog-consumable-info-container {
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 4px; 
    /* text-align: center; 
    justify-content: center; 
    align-items: center; */
}

.dialog-consumable-info {
    flex: 1;
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background-color: #303540;
    border-radius: 4px;
}

.dialog-consumable-info img {
    width: 12px;
    height: 16px;
}

.dialog-consumable-info span {
    font-size: 10px;
    color: #ffffff;
}

.equip-dialog-container {
    max-width: 132px;
    background-color: #1c1f25;
    border: 1px solid #3c616c;
    border-radius: 4px;
    padding: 8px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.equip-dialog-container > img {
    width: 32px;
    height: 32px;
    border: 1px solid #244752;
    padding: 4px;
    border-radius: 4px;
}

.equip-dialog-image {
    width: 40px;
    height: 42px;
    border: 1px solid #244752;
    padding: 4px;
    border-radius: 4px;
}

.equip-dialog-container .equip-dialog-name {
    font-size: 12px;
    margin-bottom: -6px;
    text-transform: capitalize;
    text-align: center;
} 

.equip-dialog-container .equip-dialog-lvl { 
    font-size: 10px; 
    padding: 4px; 
    border-radius: 4px; 
    color: white;
}

.dialog-spell-container .equip-dialog-lvl { 
    font-size: 10px; 
    padding: 4px; 
    border-radius: 4px; 
    color: white;
} 

.equip-dialog-container .equip-dialog-lvl span { 
    color: #71deff;
} 

.equip-dialog-container .equip-dialog-class-container { 
    display: flex; 
    flex-flow: wrap; 
    justify-content: center;
}


.equip-dialog-container .equip-dialog-class { 
    font-size: 12px; 
    padding: 4px 8px; 
    border-radius: 8px; 
    background-color: #303540; 
    margin-bottom: 4px; 
    color: white;
} 


.dialog-spell-container .equip-dialog-class { 
    font-size: 12px; 
    padding: 4px 8px; 
    border-radius: 8px; 
    background-color: #303540; 
    margin-bottom: 4px; 
    color: white;
} 

.equip-dialog-container .equip-dialog-class:last-child { 
    margin-bottom: 0;
} 

.equip-dialog-container .equip-dialog-desc {
    font-size: 10px;
    text-align: center;
    color: #71deff;
}

.equip-dialog-container .dialog-button-container {
    justify-content: center;
}

.dialog-spell-container {
    background-color: #1c1f25;
    border: 1px solid #3c616c;
    border-radius: 4px;
    padding: 6px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    max-width: 128px;
    position: relative;
}

.dialog-spell-container > img {
    width: 32px;
    height: 32px;
    border: 1px solid #244752;
    padding: 4px;
    border-radius: 4px;
    position: absolute;
    top: -16px;
    background-color: #1c1f25;    
}

.spell-wrapper {
    width: 43px;
    height: 43px;
    border: 1px solid #3e5367;
    border-radius: 6px;
    background-color: #1c1f25;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -20px;
    margin-bottom: -20px;
}

.dialog-spell-container-image {
    width: 32px;
    height: 32px;
    /* padding: 4px; */
    border-radius: 4px;
    position: absolute;
    background-color: #1c1f25;    
    background-repeat: no-repeat;
}

.dialog-spell-container p {
    font-size: 10px;
    text-align: center;
}

.dialog-spell-container .dialog-spell-name {
    margin-top: 24px;
    text-transform: capitalize;
}

.dialog-spell-container .dialog-spell-desc {
    color: #71deff;
}

.dialog-spell-info-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
}

.dialog-item-info-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 8px 0;
}

.dialog-spell-info {
    flex: 1;
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background-color: #303540;
    border-radius: 4px;
}

.dialog-spell-info img {
    width: 12px;
    height: 16px;
}

.dialog-spell-info span {
    font-size: 10px;
    color: #ffffff;
}

.dialog-spell-container .dialog-button-container {
    justify-content: center;
} 

.dialog-spell-modal {
    position: absolute; 
    top: 40px; 
    left: -25%; 
    /* background-color: #303540;  */
    background-color: #1c1f25;
    border: 1px solid #3c616c; 
    border-radius: 4px; 
    padding: 12px; 
    width: 150%;
} 

.dialog-SP-modal { 
    top: 20px; 
    left: -5%;
    width: 110%; 
    border-radius: 12px;
}

.dialog-spell-modal-text {
    font-size: 10px; 
    color: #71deff; 
    text-align: center;
    margin-bottom: 8px;
    font-family: 'Kim';
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.dialog-spell-modal-btns { 
    display: flex; 
    justify-content: center; 
} 

.dialog-spell-modal-btns > button { 
    font-size: 10px; 
    padding: 4px 6px; 
    border: 1px solid #244752; 
    border-radius: 4px; 
    color: white; 
    margin: 0 6px; 
    cursor: pointer;
}

.dialog-spell-modal-confirm { 
    background-color: darkgreen; 
}

.dialog-spell-modal-cancel { 
    background-color: darkred;
}

.dialog-item-container {
    background-color: #1c1f25;
    border: 1px solid #3f6f7d;
    border-radius: 4px;
    width: 132px;
    padding: 6px 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
}

.dialog-item-heading-bg {
    background-color: #2f404d;
    height: 24px;
    width: 97%;

    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 2px;
}

.dialog-item-heading {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 12px;
    position: absolute;
    top: -18px;
}

.dialog-item-heading img {
    width: 32px;
    height: 32px;
    background-color: #303540;
    border: 1px solid #3c616c;
    border-radius: 4px;
    padding: 4px;
}

.dialog-item-heading-image {
    width: 42px;
    height: 42px;
    background-color: #303540;
    border: 1px solid #3c616c;
    border-radius: 4px;
    padding: 4px;
    background-repeat: no-repeat;
}

.dialog-item-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.dialog-item-title span {
    font-size: 11px;
    color: #ffffff;
    text-transform: capitalize;
}

.dialog-item-desc {
    margin-top: 32px;
    color: #71deff; 
    text-align: center;
}

.dialog-item-title .dialog-item-title-info {
    font-size: 8px;
    color: #71deff;
}

.dialog-item-container .dialog-button-container {
    justify-content: center;
} 

.dialog-item-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
    width: 100%;
}

.dialog-item-info span {
    font-size: 10px;
}

.dialog-item-info .character-info-dialog-card {
    min-width: 42px;
}

.dialog-item-info .character-info-dialog-card span {
    font-size: 10px;
}

.dialog-sell {
    background-color: #8B0000 !important;
    border: none !important;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 8px !important;
}

.dialog-sell:hover {
    background-color: #A52A2A !important;
}

.dialog-sell img {
    width: 10px !important;
    height: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/itemDialog/ItemDialog.style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR;;0BAEsB;AAC1B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAS;IACT,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,UAAU;;IAEV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B","sourcesContent":[".dialog-container {\n    box-sizing: border-box;\n    background-color: #1c1f25;\n    border: 1px solid #3c616c;\n    padding: 8px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.dialog-heading {\n    font-size: 12px;\n    text-align: center;\n}\n\n.dialog-button-container {\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.dialog-button-container button {\n    flex: 0 1 auto;\n    min-width: 60px;\n    background: transparent;\n    border: 1px solid #244752;\n    border-radius: 4px;\n    padding: 4px 8px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 8px;\n    color: #ffffff;\n}\n\n.dialog-button-container button:hover {\n    border: 1px solid #71deff;\n}\n\n.dialog-button-container button img {\n    width: 10px;\n    height: 10px;\n    margin-right: 4px;\n} \n\n.character-info-dialog-container {\n    background-color: #1c1f25;\n    border: 1px solid #3c616c;\n    border-radius: 16px;\n    padding: 16px 24px; \n    font-family: 'Kim';\n} \n\n.character-info-dialog-card-container { \n    display: flex; \n    align-items: center; \n    justify-content: center; \n    margin-bottom: 8px;\n}\n\n.character-info-dialog-card {\n    border-radius: 2px;\n    display: flex;\n    justify-content: center;\n    align-items: center; \n    margin-right: 6px;\n}\n\n.character-info-dialog-card span {\n    font-size: 12px;\n    font-weight: 600;\n    color: #ffffff;\n    padding: 2px;\n}\n\n.character-info-dialog-card-text {\n    display: flex;\n    justify-content: space-between;\n    /* min-width: 28px; */\n    margin-right: 4px;\n    font-size: 12px; \n    color: white;\n}\n\n.character-info-addition {\n    display: flex;\n} \n\n.character-info-dialog-control { \n    display: flex; \n    justify-content: center; \n    gap: 8px;\n    color: white; \n    margin-bottom: 12px;\n}\n\n.character-info-dialog-control-btn { \n    padding: 4px 8px; \n    border: 1px solid #3c616c; \n    border-radius: 4px; \n} \n\n.character-info-dialog-control-btn:hover { \n    cursor: pointer; \n}\n\n.character-info-dialog-control-val { \n    padding: 4px 24px; \n    border: 1px solid #3c616c; \n    border-radius: 4px; \n}\n\n.character-info-dialog-container .dialog-button-container { \n    justify-content: center;\n}\n\n.dialog-consumable-info-container {\n    display: grid;\n    grid-template-columns: repeat(2, 2fr);\n    gap: 4px; \n    /* text-align: center; \n    justify-content: center; \n    align-items: center; */\n}\n\n.dialog-consumable-info {\n    flex: 1;\n    padding: 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    background-color: #303540;\n    border-radius: 4px;\n}\n\n.dialog-consumable-info img {\n    width: 12px;\n    height: 16px;\n}\n\n.dialog-consumable-info span {\n    font-size: 10px;\n    color: #ffffff;\n}\n\n.equip-dialog-container {\n    max-width: 132px;\n    background-color: #1c1f25;\n    border: 1px solid #3c616c;\n    border-radius: 4px;\n    padding: 8px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.equip-dialog-container > img {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #244752;\n    padding: 4px;\n    border-radius: 4px;\n}\n\n.equip-dialog-image {\n    width: 40px;\n    height: 42px;\n    border: 1px solid #244752;\n    padding: 4px;\n    border-radius: 4px;\n}\n\n.equip-dialog-container .equip-dialog-name {\n    font-size: 12px;\n    margin-bottom: -6px;\n    text-transform: capitalize;\n    text-align: center;\n} \n\n.equip-dialog-container .equip-dialog-lvl { \n    font-size: 10px; \n    padding: 4px; \n    border-radius: 4px; \n    color: white;\n}\n\n.dialog-spell-container .equip-dialog-lvl { \n    font-size: 10px; \n    padding: 4px; \n    border-radius: 4px; \n    color: white;\n} \n\n.equip-dialog-container .equip-dialog-lvl span { \n    color: #71deff;\n} \n\n.equip-dialog-container .equip-dialog-class-container { \n    display: flex; \n    flex-flow: wrap; \n    justify-content: center;\n}\n\n\n.equip-dialog-container .equip-dialog-class { \n    font-size: 12px; \n    padding: 4px 8px; \n    border-radius: 8px; \n    background-color: #303540; \n    margin-bottom: 4px; \n    color: white;\n} \n\n\n.dialog-spell-container .equip-dialog-class { \n    font-size: 12px; \n    padding: 4px 8px; \n    border-radius: 8px; \n    background-color: #303540; \n    margin-bottom: 4px; \n    color: white;\n} \n\n.equip-dialog-container .equip-dialog-class:last-child { \n    margin-bottom: 0;\n} \n\n.equip-dialog-container .equip-dialog-desc {\n    font-size: 10px;\n    text-align: center;\n    color: #71deff;\n}\n\n.equip-dialog-container .dialog-button-container {\n    justify-content: center;\n}\n\n.dialog-spell-container {\n    background-color: #1c1f25;\n    border: 1px solid #3c616c;\n    border-radius: 4px;\n    padding: 6px 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    max-width: 128px;\n    position: relative;\n}\n\n.dialog-spell-container > img {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #244752;\n    padding: 4px;\n    border-radius: 4px;\n    position: absolute;\n    top: -16px;\n    background-color: #1c1f25;    \n}\n\n.spell-wrapper {\n    width: 43px;\n    height: 43px;\n    border: 1px solid #3e5367;\n    border-radius: 6px;\n    background-color: #1c1f25;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -20px;\n    margin-bottom: -20px;\n}\n\n.dialog-spell-container-image {\n    width: 32px;\n    height: 32px;\n    /* padding: 4px; */\n    border-radius: 4px;\n    position: absolute;\n    background-color: #1c1f25;    \n    background-repeat: no-repeat;\n}\n\n.dialog-spell-container p {\n    font-size: 10px;\n    text-align: center;\n}\n\n.dialog-spell-container .dialog-spell-name {\n    margin-top: 24px;\n    text-transform: capitalize;\n}\n\n.dialog-spell-container .dialog-spell-desc {\n    color: #71deff;\n}\n\n.dialog-spell-info-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4px;\n}\n\n.dialog-item-info-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin: 8px 0;\n}\n\n.dialog-spell-info {\n    flex: 1;\n    padding: 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    background-color: #303540;\n    border-radius: 4px;\n}\n\n.dialog-spell-info img {\n    width: 12px;\n    height: 16px;\n}\n\n.dialog-spell-info span {\n    font-size: 10px;\n    color: #ffffff;\n}\n\n.dialog-spell-container .dialog-button-container {\n    justify-content: center;\n} \n\n.dialog-spell-modal {\n    position: absolute; \n    top: 40px; \n    left: -25%; \n    /* background-color: #303540;  */\n    background-color: #1c1f25;\n    border: 1px solid #3c616c; \n    border-radius: 4px; \n    padding: 12px; \n    width: 150%;\n} \n\n.dialog-SP-modal { \n    top: 20px; \n    left: -5%;\n    width: 110%; \n    border-radius: 12px;\n}\n\n.dialog-spell-modal-text {\n    font-size: 10px; \n    color: #71deff; \n    text-align: center;\n    margin-bottom: 8px;\n    font-family: 'Kim';\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.dialog-spell-modal-btns { \n    display: flex; \n    justify-content: center; \n} \n\n.dialog-spell-modal-btns > button { \n    font-size: 10px; \n    padding: 4px 6px; \n    border: 1px solid #244752; \n    border-radius: 4px; \n    color: white; \n    margin: 0 6px; \n    cursor: pointer;\n}\n\n.dialog-spell-modal-confirm { \n    background-color: darkgreen; \n}\n\n.dialog-spell-modal-cancel { \n    background-color: darkred;\n}\n\n.dialog-item-container {\n    background-color: #1c1f25;\n    border: 1px solid #3f6f7d;\n    border-radius: 4px;\n    width: 132px;\n    padding: 6px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    position: relative;\n}\n\n.dialog-item-heading-bg {\n    background-color: #2f404d;\n    height: 24px;\n    width: 97%;\n\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    border-radius: 2px;\n}\n\n.dialog-item-heading {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-start;\n    gap: 12px;\n    position: absolute;\n    top: -18px;\n}\n\n.dialog-item-heading img {\n    width: 32px;\n    height: 32px;\n    background-color: #303540;\n    border: 1px solid #3c616c;\n    border-radius: 4px;\n    padding: 4px;\n}\n\n.dialog-item-heading-image {\n    width: 42px;\n    height: 42px;\n    background-color: #303540;\n    border: 1px solid #3c616c;\n    border-radius: 4px;\n    padding: 4px;\n    background-repeat: no-repeat;\n}\n\n.dialog-item-title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.dialog-item-title span {\n    font-size: 11px;\n    color: #ffffff;\n    text-transform: capitalize;\n}\n\n.dialog-item-desc {\n    margin-top: 32px;\n    color: #71deff; \n    text-align: center;\n}\n\n.dialog-item-title .dialog-item-title-info {\n    font-size: 8px;\n    color: #71deff;\n}\n\n.dialog-item-container .dialog-button-container {\n    justify-content: center;\n} \n\n.dialog-item-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 2px 0;\n    width: 100%;\n}\n\n.dialog-item-info span {\n    font-size: 10px;\n}\n\n.dialog-item-info .character-info-dialog-card {\n    min-width: 42px;\n}\n\n.dialog-item-info .character-info-dialog-card span {\n    font-size: 10px;\n}\n\n.dialog-sell {\n    background-color: #8B0000 !important;\n    border: none !important;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 8px !important;\n}\n\n.dialog-sell:hover {\n    background-color: #A52A2A !important;\n}\n\n.dialog-sell img {\n    width: 10px !important;\n    height: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
